import * as React from 'react';

const ArrowRight: React.FunctionComponent = () => {
    return (
        <>
            <svg
                width="15px"
                style={{ transform: 'translateY(1px)' }}
                height="15px"
                viewBox="0 0 15 15"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
            >
                <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g id="Dashboard" transform="translate(-304.000000, -105.000000)">
                        <g id="Group-4" transform="translate(264.000000, 104.000000)">
                            <g id="control/screening/arrow" transform="translate(40.000000, 1.000000)">
                                <rect id="Rectangle" fillOpacity="0" fill="#D8D8D8" x="0" y="0" width="15" height="15"></rect>
                                <path d="M6,4 L10,8 L6,12" id="Path-19" strokeOpacity="0.34" stroke="#000000" strokeWidth="1.5"></path>
                            </g>
                        </g>
                    </g>
                </g>
            </svg>
        </>
    );
};

export default ArrowRight;
